<template>
  <div>
    <v-dialog v-model="show" persistent max-width="900px" width="900px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>عرض الملاحظات</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 10px"></div>

          <h3>{{ notes }}</h3>

          <img crossOrigin="anonymous" :src="`${$store.state.apiUrlFees}/${imagePath}`" @click="fullScreenImage($event)" alt="" width="800" />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text @click="show = false" v-on:keyup.enter="show = false"> تم </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="indigo" @click="show = true" v-bind="attrs" v-on="on"><v-icon dark> mdi-information-variant </v-icon></v-btn>
      </template>
      <span>عرض الملاحظات</span>
    </v-tooltip>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
export default {
  props: {
    notes: String,
    imagePath: String,
  },
  data() {
    return {
      studentRequiredFormRules: [(v) => !!v || "حقل مطلوب . يرجى ادخال قيمة"],
      show: false,
    };
  },

  methods: {
    fullScreenImage(e) {
      const doc = new jsPDF();

      const getBase64StringFromDataURL = (dataURL) => dataURL.replace("data:", "").replace(/^.+,/, "");

      const canvas = document.createElement("canvas");

      canvas.width = e.target.naturalWidth;
      canvas.height = e.target.naturalHeight;

      canvas.getContext("2d").drawImage(e.target, 0, 0);

      const dataURL = canvas.toDataURL();

      const base64 = getBase64StringFromDataURL(dataURL);

      doc.addImage(base64, 0, 0, 210, 300);
      doc.save("document.pdf");

      canvas.remove();

      // let imageWindow = window.open(
      //   "",
      //   "",
      //   "left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0"
      // );

      // imageWindow.document.write(`<!DOCTYPE html>
      //             <html>
      //             <head></head>
      //             <body></body> <img src="${this.$store.state.apiUrl}/${image.imagePath}"  style="margin-top: 10px;"></html>`);

      // setTimeout(() => {
      //   imageWindow.document.close();
      //   imageWindow.focus();
      //   imageWindow.print();
      //   imageWindow.close();
      // }, 500);
      // //  setTimeout(function () {
      // //  }, 500);
    },
    saveData() {
      let self = this;
      console.log(self.collegeNumber, self.yearStudyId);

      if (self.notes) {
        let data = {
          collegeNumber: self.collegeNumber,
          yearStudyId: self.yearStudyId,
          notes: self.notes,
        };

        this.$http
          .post(`${this.$store.state.apiUrlRegistration}/addLevelNote`, data, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            this.show = false;
            this.$toasted.success("تم اضافه البيانات");
            this.$emit("reloadTask");
          })
          .catch((err) => {
            this.$toasted.error(" حدث خطأ في البيانات");
          });
      } else {
        this.$toasted.error("لا يمكن ترك الحقل فارغ");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
